import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5be1d1b0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "honor-list"
};
const _hoisted_2 = {
  key: 0,
  class: "top-background"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 1,
  class: "title"
};
const _hoisted_5 = {
  class: "content"
};
const _hoisted_6 = {
  class: "project-card"
};
const _hoisted_7 = {
  key: 1,
  class: "project-info"
};
const _hoisted_8 = {
  class: "project-name"
};
const _hoisted_9 = {
  key: 0,
  class: "project-time"
};
const _hoisted_10 = {
  class: "honor-list-container"
};
const _hoisted_11 = {
  key: 0,
  class: "current-honors"
};
const _hoisted_12 = {
  class: "honors-header"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/honor_title_icon.png",
  alt: "荣誉时刻",
  class: "title-image"
})], -1));
const _hoisted_14 = {
  class: "honors-summary"
};
const _hoisted_15 = {
  class: "summary-text"
};
const _hoisted_16 = /*#__PURE__*/_createTextVNode("荣誉总数累积 ");
const _hoisted_17 = {
  class: "total-count"
};
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 项");
const _hoisted_19 = {
  class: "honor-grid"
};
const _hoisted_20 = {
  class: "honor-content"
};
const _hoisted_21 = {
  class: "honor-title-row"
};
const _hoisted_22 = {
  class: "honor-title"
};
const _hoisted_23 = {
  class: "honor-num"
};
const _hoisted_24 = {
  class: "honor-time"
};
const _hoisted_25 = {
  key: 1,
  class: "history-honors"
};
const _hoisted_26 = {
  class: "history-section-title"
};
const _hoisted_27 = {
  class: "timeline-container"
};
const _hoisted_28 = {
  key: 0,
  class: "timeline-line"
};
const _hoisted_29 = {
  class: "content-container"
};
const _hoisted_30 = {
  class: "history-header"
};
const _hoisted_31 = {
  class: "title-with-icon"
};
const _hoisted_32 = {
  class: "history-title"
};
const _hoisted_33 = {
  key: 0,
  class: "history-badge"
};
const _hoisted_34 = {
  class: "history-time"
};
import { reactive, ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import env from "md-base-tools/env";
import { GoBack } from "@/utils/tools";
import { getProjectHonorInfo, getProHonorList, getProHonorShareImg } from "@api";
import { mdToast } from "@/utils/tools";
import HonorPoster from "@@/project/honor-poster";
import { DownloadImage } from "../../../utils/tools";
export default {
  setup(__props) {
    const route = useRoute();

    // 页面状态
    const state = reactive({
      statusBarH: 10,
      refreshing: false,
      loading: false,
      is_next: true,
      page: 1,
      page_size: 20,
      // 项目信息
      projectInfo: null,
      honorTotal: 0,
      currentHonors: [],
      // 历史荣誉列表
      historyList: [],
      historyTotal: 0,
      // 展开状态
      isExpanded: false,
      // 海报弹窗状态
      showPoster: false,
      selectedImageUrl: '',
      //分享海报
      shareImageUrl: ''
    });
    const isFix = ref(false);

    // 初始化数据
    onRefresh();

    // 计算显示的荣誉列表
    const displayedHonors = computed(() => {
      if (state.isExpanded) {
        return state.currentHonors;
      }
      return state.currentHonors.slice(0, 4);
    });

    // 处理分享
    const handleShareAction = async () => {
      if (state.shareImageUrl != '') {
        if (env.isModianIos() || env.isModianAndroid()) {
          handleShareToNative(state.shareImageUrl);
        } else if (env.isWxApp()) {
          // eslint-disable-next-line no-undef
          wx.previewImage({
            urls: [state.shareImageUrl]
          });
        } else {
          state.selectedImageUrl = state.shareImageUrl;
          state.showPoster = true;
        }
      } else {
        const {
          status,
          data,
          message
        } = await getProHonorShareImg({
          pro_id: route.query.pro_id
        });
        if (status == 0) {
          state.shareImageUrl = data.share_img;
          if (env.isModianIos() || env.isModianAndroid()) {
            handleShareToNative(state.shareImageUrl);
          } else if (env.isWxApp()) {
            // eslint-disable-next-line no-undef
            wx.previewImage({
              urls: [state.shareImageUrl]
            });
          } else {
            state.selectedImageUrl = state.shareImageUrl;
            state.showPoster = true;
          }
        } else {
          mdToast(message);
        }
      }
    };
    const handleShareToNative = imageUrl => {
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "openImageShareTool",
          functionParams: imageUrl
        });
      }
    };

    // 切换展开状态
    const toggleExpand = () => {
      state.isExpanded = !state.isExpanded;
    };

    // 处理图片点击
    const handleImageClick = item => {
      if (env.isWxApp()) {
        // eslint-disable-next-line no-undef
        wx.previewImage({
          urls: [item.img]
        });
      } else {
        state.selectedImageUrl = item.img;
        state.showPoster = true;
      }
    };

    // 关闭海报
    const closePoster = () => {
      state.showPoster = false;
    };

    // 处理下载
    const handleDownload = imageUrl => {
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "saveImageFromUrl",
          functionParams: imageUrl,
          webFun: () => {},
          callBack: e => {
            if (e.errorCode == 0) {
              mdToast('保存成功');
            } else {
              mdToast(e.errorMessage || '保存失败');
            }
          }
        });
      } else {
        //H5 直接下载 
        DownloadImage(imageUrl);
      }
    };

    // 处理分享
    const handleShare = imageUrl => {
      handleShareToNative(imageUrl);
    };
    onMounted(() => {
      document.title = "荣誉时刻";

      // 捕获全局错误
      window.addEventListener('error', e => {
        console.error('Global error caught:', e.message, e.filename, e.lineno, e.colno);
      });

      // 如果是APP端，设置状态栏颜色&获取设备信息
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "webNavColor",
          functionParams: {
            statusBarColorIsWhite: '0'
          }
        });

        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "onGetDeviceInfo",
          functionParams: {},
          callBack: e => {
            state.statusBarH = e.data.statusBarH;
          }
        });
      }
    });

    // 是否吸顶
    function handleStickyAction(is_fix) {
      isFix.value = is_fix ? 1 : 0;
    }

    // 返回
    function handleGoBack() {
      GoBack();
    }

    // 下拉刷新
    async function onRefresh() {
      state.refreshing = true;
      state.page = 1;
      await Promise.all([loadProjectInfo(), loadHistoryList()]);
      state.refreshing = false;
    }

    // 上拉加载更多
    function onLoadMore() {
      loadHistoryList();
    }

    // 加载项目信息和当前荣誉
    async function loadProjectInfo() {
      try {
        const {
          status,
          data,
          message
        } = await getProjectHonorInfo({
          pro_id: route.query.pro_id
        });
        console.log('data', data, message, status);
        if (status == 0) {
          state.projectInfo = data.pro_info;
          state.currentHonors = data.list || [];
          state.honorTotal = data.total || 0;
        } else {
          mdToast(message);
        }
      } catch (error) {
        console.error('加载项目荣誉信息失败:', error);
      }
    }

    // 加载历史荣誉列表
    async function loadHistoryList() {
      state.loading = true;
      try {
        const {
          status,
          data,
          message
        } = await getProHonorList({
          page: state.page,
          page_size: state.page_size,
          pro_id: route.query.pro_id
        });
        state.loading = false;
        if (status === 0) {
          state.is_next = data.is_next;
          if (state.page === 1) {
            state.historyList = data.list || [];
            state.historyTotal = data.total || 0;
          } else {
            state.historyList.push(...(data.list || []));
          }
          if (data.list && data.list.length > 0) {
            state.page++;
          }
        } else {
          mdToast(message);
        }
      } catch (error) {
        state.loading = false;
        console.error('加载历史荣誉列表失败:', error);
      }
    }
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_sticky = _resolveComponent("van-sticky");
      const _component_van_list = _resolveComponent("van-list");
      const _component_Error = _resolveComponent("Error");
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(state).projectInfo ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
        class: "top-cover",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/project_honor_top_cover.png', 750)
      }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _createVNode(_component_van_sticky, {
        onChange: handleStickyAction
      }, {
        default: _withCtx(() => [_createElementVNode("header", {
          class: _normalizeClass([{
            'headerAndroid': _unref(env).isModianAndroid()
          }, {
            'isFix': isFix.value
          }]),
          style: _normalizeStyle({
            'padding-top': _unref(state).statusBarH + 'px'
          })
        }, [_unref(env).isModianIos() || _unref(env).isModianIosNew() || _unref(env).isModianAndroid() ? (_openBlock(), _createBlock(_component_van_image, {
          key: 0,
          class: _normalizeClass(["back-icon", {
            'isFix': isFix.value
          }]),
          "lazy-load": "",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/project_honor_nav_back.png', 40),
          onClick: _withModifiers(handleGoBack, ["stop"])
        }, null, 8, ["class", "src", "onClick"])) : _createCommentVNode("", true), isFix.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, "荣誉时刻")) : _createCommentVNode("", true)], 6)]),
        _: 1
      }), _createVNode(_component_van_pull_refresh, {
        modelValue: _unref(state).refreshing,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(state).refreshing = $event),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_unref(state).projectInfo && _unref(state).projectInfo.img ? (_openBlock(), _createBlock(_component_van_image, {
          key: 0,
          class: "project-cover",
          src: _ctx.$imgUrlFilter(_unref(state).projectInfo.img, 160)
        }, null, 8, ["src"])) : _createCommentVNode("", true), _unref(state).projectInfo ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_unref(state).projectInfo.pro_title), 1), _unref(state).projectInfo.start_time || _unref(state).projectInfo.sale_day ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(state).projectInfo.start_time || '') + " " + _toDisplayString(_unref(state).projectInfo.sale_day || ''), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, [_unref(state).projectInfo && _unref(state).currentHonors && _unref(state).currentHonors.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", {
          class: "share-btn",
          onClick: handleShareAction
        }, [_createVNode(_component_van_image, {
          class: "share-icon",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/honor_share_icon.png', 48)
        }, null, 8, ["src"])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(state).honorTotal), 1), _hoisted_18])]), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedHonors), (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "honor-card",
            key: index
          }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_23, _toDisplayString(item.num), 1)]), _createElementVNode("div", _hoisted_24, _toDisplayString(item.time), 1)])]);
        }), 128))]), _unref(state).currentHonors.length > 4 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "expand-btn",
          onClick: toggleExpand
        }, [_createElementVNode("span", null, _toDisplayString(_unref(state).isExpanded ? '收起' : '展开'), 1), _createVNode(_component_van_image, {
          class: _normalizeClass(["expand-icon", {
            'rotated': _unref(state).isExpanded
          }]),
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/honor_arrow.png', 24)
        }, null, 8, ["class", "src"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _unref(state).projectInfo ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, "众筹成就" + _toDisplayString(_unref(state).historyTotal) + "项", 1), _createVNode(_component_van_list, {
          loading: _unref(state).loading,
          "onUpdate:loading": _cache[0] || (_cache[0] = $event => _unref(state).loading = $event),
          finished: !_unref(state).is_next,
          "immediate-check": false,
          onLoad: onLoadMore
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).historyList, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "history-item",
              key: index
            }, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", {
              class: _normalizeClass(["timeline-dot", {
                'first': index === 0,
                'hollow': index > 0
              }])
            }, [index === 0 ? (_openBlock(), _createBlock(_component_van_image, {
              key: 0,
              class: "timeline-icon",
              src: 'https://p6.moimg.net/mdwxapp/honor_history_latest_icon.png'
            }, null, 8, ["src"])) : _createCommentVNode("", true)], 2), index < _unref(state).historyList.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_28)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [item.icon ? (_openBlock(), _createBlock(_component_van_image, {
              key: 0,
              class: "title-icon",
              src: _ctx.$imgUrlFilter(item.icon, 32)
            }, null, 8, ["src"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_32, _toDisplayString(item.title), 1)]), item.num ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(item.num), 1)) : _createCommentVNode("", true)]), item.img ? (_openBlock(), _createBlock(_component_van_image, {
              key: 0,
              class: "history-img",
              src: _ctx.$imgUrlFilter(item.img, 200),
              onClick: $event => handleImageClick(item)
            }, null, 8, ["src", "onClick"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_34, _toDisplayString(item.time), 1)])]);
          }), 128))]),
          _: 1
        }, 8, ["loading", "finished"])])) : _createCommentVNode("", true), !_unref(state).loading && _unref(state).historyList.length === 0 && _unref(state).projectInfo && !_unref(state).refreshing ? (_openBlock(), _createBlock(_component_Error, {
          key: 2,
          message: "暂无荣誉记录",
          class: "empty-box"
        })) : _createCommentVNode("", true)])])]),
        _: 1
      }, 8, ["modelValue"]), _unref(state).showPoster ? (_openBlock(), _createBlock(_unref(HonorPoster), {
        key: 1,
        "image-url": _unref(state).selectedImageUrl,
        onClose: closePoster,
        onDownload: handleDownload,
        onShare: handleShare
      }, null, 8, ["image-url"])) : _createCommentVNode("", true)]);
    };
  }
};